<div class="container my-24 sm:my-30">
  <div class="mx-auto flex max-w-lg justify-center rounded-lg p-8 shadow-md ring-1 ring-zinc-900/10 dark:ring-white/10">
    <div class="flex flex-col">
      <h1 class="mb-6 text-center text-2xl font-bold text-zinc-900 uppercase dark:text-zinc-200">
        Reset Password
      </h1>
      <p *ngIf="!changeSuccess" class="mb-8 sm:px-4">
        Provide the email address associated with your account. You will recive
        an email with instructions on how reset your password.
      </p>
      <form class="flex flex-col items-center gap-1" [formGroup]="recoverForm" (ngSubmit)="onSubmit()"
        *ngIf="!changeSuccess">
        <div>
          <input type="text" id="email" formControlName="email"
            class="rounded-lg border px-3 py-[calc(--spacing(2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
            placeholder="Enter Email" />
        </div>
        <div class="relative flex h-6 w-full justify-center">
          <app-embedded-alert [error]="error" [success]="success" [persistSuccess]="true"></app-embedded-alert>
        </div>
        <div>
          <button
            [class]="recoverForm.valid 
              ? 'flex cursor-pointer rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none'
              : 'flex cursor-not-allowed rounded-lg bg-zinc-400 px-3 py-2 font-semibold text-zinc-100 outline-offset-2'"
            type="submit" [disabled]="!recoverForm.valid || fetchingRecoveryToken">
            <span class="pr-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
              </svg>
            </span>
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>